import React, { useContext } from 'react';
import Product from './product/Product';
import Selectable from '../common/Selectable';
import { ProductTypeWithClaims } from '../common/CommonTypes';
import { VehicleContext } from '../../context/VehicleContext';
import { useTranslation } from 'react-i18next';
import Badge from 'components/common/badge/Badge';
import { ClaimStatuses, FeatureState, ProductStatuses } from 'Constants/Common';
import { SiteContext } from 'context/SiteContext';

export type PoliciesProps = {
    vehicleIndex: number;
    selectedPolicyReference: string;
    policies: ProductTypeWithClaims[];
    onPolicySelected: (productReference: string) => void;
};

const Policies = ({
    vehicleIndex,
    selectedPolicyReference,
    policies,
    onPolicySelected
}: PoliciesProps): JSX.Element => {
    const { setSelectedVehicle } = useContext(VehicleContext);
    const { t } = useTranslation();
    const { features } = useContext(SiteContext);

    const onPolicyClicked = (selected: boolean, policyReference: string) => {
        if (selected) {
            onPolicySelected(policyReference);
            setSelectedVehicle(vehicleIndex);
        } else {
            onPolicySelected('');
        }
    };

    const ActiveClaimsBadge = ({
        openClaims
    }: {
        openClaims: ProductTypeWithClaims['claims'];
    }) => (
        <Badge color='info'>
            {t('active_claim')}
            <Badge color='light' className=' ms-1'>
                {openClaims.length}
            </Badge>
        </Badge>
    );

    return (
        <div className='card-body'>
            {policies.map((policy, index) => {
                const openClaims =
                    policy.status === ProductStatuses.Active &&
                    policy.claims.filter(
                        (r) => r.status === ClaimStatuses.Open
                    );

                return (
                    <Selectable
                        id={`selectable-product-${index.toString()}`}
                        onClicked={(selected) =>
                            onPolicyClicked(selected, policy.reference)
                        }
                        selected={policy.reference === selectedPolicyReference}
                        hasSelectableButton={true}
                        style={{
                            border: '1px solid #ced4da',
                            marginTop: '10px'
                        }}
                        key={`product-selectable-${vehicleIndex.toString()}-${index.toString()}`}>
                        <Product
                            id={`product-${vehicleIndex.toString()}-${index.toString()}`}
                            product={policy}
                        />
                        {features.ActiveClaim === FeatureState.On &&
                            !!openClaims.length && (
                                <div className='mt-3 d-flex flex-wrap gap-2'>
                                    <ActiveClaimsBadge
                                        openClaims={openClaims}
                                    />
                                </div>
                            )}
                    </Selectable>
                );
            })}
        </div>
    );
};

export default Policies;
